import { Component } from 'react';
import withAuth from '../../../components/withAuth';
import {compose} from "redux";
import {connect} from "react-redux";
import {setHeader} from '../../../redux/analyseRisques/analyseRisquesActions'
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import SelectWithModal from '../../../components/SelectWithModal/SelectWithModal'
import {arIsReadonly} from '../../../redux/analyseRisques/analyseRisquesStatusActions'
import Input from '@mui/material/Input';
import './AnalyseRisquesTabs.css';
import {clone} from '../../../utils'
import {TYPING_TIMEOUT} from '../../../constants'
import CustomizedTextField from '../../../components/Input/CustomizedTextField';
import CustomizedSelectWithChips from '../../../components/Input/CustomizedSelectWithChips';

class AnalyseRisquesSecurity extends Component {

    constructor(props){
        super(props);
        this.state={
            specificsEquipments: props.header.specificsEquipments,
            additionnalInformations: props.header.additionnalInformations,
            place: props.header.place,
            equipment: props.header.equipment,
            additionnalInformationAccreditations: props.header.additionnalInformationAccreditations,
            specificsEquipmentsTypingTimeout: null,
            additionnalInformationsTypingTimeout: null,
            placeTypingTimeout: null,
            equipmentTypingTimeout: null,
            additionnalInformationAccreditationsTypingTimeout: null,
            timeout: TYPING_TIMEOUT,
        }
    }

    onPpeChange(event){
        let value = event.target.value;
        let newPpe = [];
        value.forEach((v) => 
        {
            let epi = this.props.ppeList.filter(ppe => ppe.type === "epi" && ppe.use_in_spp).find(p => p.id === v);
            if (epi) {
                newPpe.push({value: epi.id, label: epi.name});
            }            
        });
        const header = clone(this.props.header);
        header.ppe = newPpe;
        this.props.setHeader(header);
    }

    removeEpiFromPpe(value){
        const header = clone(this.props.header);
        let element = header.ppe.find(e => e.value === value);
        if (element) {
            let index = header.ppe.indexOf(element);
            if (index > -1) {
                header.ppe.splice(index, 1);
            }
        }
        this.props.setHeader(header);
    }

    onNecessaryEquipmentsChange(value){
        const header = clone(this.props.header);
        header.necessaryEquipments = value;
        this.props.setHeader(header);
    }

    onAvailableEquipmentsChange(value){
        const header = clone(this.props.header);
        header.availableEquipments = value;
        this.props.setHeader(header);
    }

    onSpecificsEquipmentsChange(event){
        let value = event.target.value;

        if (this.state.specificsEquipmentsTypingTimeout) {
            clearTimeout(this.state.specificsEquipmentsTypingTimeout);
        }

        this.setState({
            specificsEquipments: value,
            specificsEquipmentsTypingTimeout: setTimeout(() => {
                const header = clone(this.props.header);
                header.specificsEquipments = value;
                this.props.setHeader(header);
            }, this.state.timeout)
        });
    }

    onInstructionsChange(value){
        const header = clone(this.props.header);
        header.instructions = value;
        this.props.setHeader(header);
    }

    onAdditionnalInformationsChange(event){
        let value = event.target.value;

        if (this.state.additionnalInformationsTypingTimeout) {
            clearTimeout(this.state.additionnalInformationsTypingTimeout);
        }

        this.setState({
            additionnalInformations: value,
            additionnalInformationsTypingTimeout: setTimeout(() => {
                const header = clone(this.props.header);
                header.additionnalInformations = value;
                this.props.setHeader(header);
            }, this.state.timeout)
        });
    }

    onPlaceChange(event){
        let value = event.target.value;

        if (this.state.placeTypingTimeout) {
            clearTimeout(this.state.placeTypingTimeout);
        }

        this.setState({
            place: value,
            placeTypingTimeout: setTimeout(() => {
                const header = clone(this.props.header);
                header.place = value;
                this.props.setHeader(header);
            }, this.state.timeout)
        });
    }

    onEquipmentChange(event){
        let value = event.target.value;

        if (this.state.equipmentTimeout) {
            clearTimeout(this.state.equipmentTimeout);
        }

        this.setState({
            equipment: value,
            equipmentTimeout: setTimeout(() => {
                const header = clone(this.props.header);
                header.equipment = value;
                this.props.setHeader(header);
            }, this.state.timeout)
        });
    }

    onAccreditationsChange(value){
        const header = clone(this.props.header);
        header.accreditations = value;
        this.props.setHeader(header);
    }

    onAdditionnalInformationAccreditationsChange(event){
        let value = event.target.value;

        if (this.state.additionnalInformationAccreditationsTimeout) {
            clearTimeout(this.state.additionnalInformationAccreditationsTimeout);
        }

        this.setState({
            additionnalInformationAccreditations: value,
            additionnalInformationAccreditationsTimeout: setTimeout(() => {
                const header = clone(this.props.header);
                header.additionnalInformationAccreditations = value;
                this.props.setHeader(header);
            }, this.state.timeout)
        });
    }

    render() {

        let selectedAccreditations = this.props.header.accreditations;

        selectedAccreditations.forEach((a) => {
            if(a.label)
                return;

            let accreditationsFound = this.props.accreditations.filter((currentAccreditation) => currentAccreditation.id === a.value);

            if(accreditationsFound.length > 0)
                a.label = accreditationsFound[0].name;
        })

        let headerPpeIds = this.props.header.ppe.map(e => e.value);

        return (
            <div className="full-height">
                <div className="col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding">
                    <div className="row">
                        <Card className={"card col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding " + (arIsReadonly(this.props.header) ? "disabled" : "")}>
                            <CardHeader style={{ color: 'rgb(117, 117, 117)' }} title="EPI" className="analyse-risques-card-title"/>
                            <CardContent>
                                <div className="row">
                                    <div className="col-lg-6 col-md-6 col-sm-12 col-12 control-margin-top">
                                        <CustomizedSelectWithChips
                                            id="ppe"
                                            label={"EPI"}
                                            onDelete={this.removeEpiFromPpe.bind(this)}
                                            value={headerPpeIds}
                                            name="ppe"
                                            multiple
                                            className="full_size"
                                            menuPlacement="auto"
                                            classNamePrefix="select"
                                            noOptionsMessage={() => "Aucune valeur"}
                                            menuclasses="select-popup"
                                            onChange={this.onPpeChange.bind(this)}
                                            options={this.props.ppeList.filter(ppe => ppe.type === "epi" && ppe.use_in_spp).map((ppe) => {
                                                return {
                                                    value: ppe.id,
                                                    label: ppe.name
                                                }
                                            })}
                                        />
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-12 col-12 control-margin-top">
                                        <SelectWithModal
                                            id="necessary-equipments"
                                            label={"Equipements nécessaires"}
                                            onValidate={this.onNecessaryEquipmentsChange.bind(this)}
                                            multiple
                                            menuPlacement="auto"
                                            value={this.props.header.necessaryEquipments}
                                            className="full_size"
                                            input={<Input id="necessary-equipments" />}
                                            options={this.props.ppeList.filter(ppe => ppe.type === "equipment" && ppe.use_in_spp).map((ppe) => {
                                                return {
                                                    value: ppe.id,
                                                    label: ppe.name
                                                }
                                            })}
                                        />
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-12 col-12 control-margin-top">
                                        <SelectWithModal
                                            label={"Equipements disponibles"}
                                            onValidate={this.onAvailableEquipmentsChange.bind(this)}
                                            id="available-equipments"
                                            multiple
                                            menuPlacement="top"
                                            value={this.props.header.availableEquipments}
                                            className="full_size"
                                            input={<Input id="available-equipments" />}
                                            options={this.props.ppeList.filter(ppe => ppe.type === "equipment" && ppe.use_in_spp).map((ppe) => {
                                                return {
                                                    value: ppe.id,
                                                    label: ppe.name
                                                }
                                            })}
                                        />
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-12 col-12 control-margin-top">
                                        <CustomizedTextField
                                            id="specifics-equipments"
                                            label={"Equipements spécifiques"}
                                            className="full_size"
                                            multiline
                                            value={this.state.specificsEquipments}
                                            onChange={this.onSpecificsEquipmentsChange.bind(this)}
                                        />
                                    </div>
                                </div>
                            </CardContent>
                        </Card>
                    </div>
                </div>
                <div className="col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding">
                    <div className="row">
                        <Card className={"card col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding " + (arIsReadonly(this.props.header) ? "disabled" : "")}>
                            <CardHeader style={{ color: 'rgb(117, 117, 117)' }} title="Instructions particulières" className="analyse-risques-card-title"/>
                            <CardContent>
                                <div className="row">
                                    <div className="col-lg-6 col-md-6 col-sm-12 col-12 control-margin-top">
                                        <SelectWithModal
                                            label={"Instructions"}
                                            onValidate={this.onInstructionsChange.bind(this)}
                                            id="instructions"
                                            multiple
                                            menuPlacement="top"
                                            value={this.props.header.instructions}
                                            className="full_size"
                                            input={<Input id="instructions" />}
                                            options={this.props.instructionTypes.filter(i => i.measure_type === "instruction").map((ppe) => {
                                                return {
                                                    value: ppe.id,
                                                    label: ppe.name
                                                }
                                            })}
                                        />
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-12 col-12 control-margin-top">
                                        <CustomizedTextField
                                            id="additionnal-informations"
                                            label={"Informations supplémentaires"}
                                            className="full_size"
                                            multiline
                                            value={this.state.additionnalInformations}
                                            onChange={this.onAdditionnalInformationsChange.bind(this)}
                                        />
                                    </div>
                                </div>
                            </CardContent>
                        </Card>
                    </div>
                </div>
                <div className="col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding">
                    <div className="row">
                        <Card className={"card col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding " + (arIsReadonly(this.props.header) ? "disabled" : "")}>
                            <CardHeader style={{ color: 'rgb(117, 117, 117)' }} title="Mise à dispo. EE" className="analyse-risques-card-title"/>
                            <CardContent>
                                <div className="row">
                                    <div className="col-lg-6 col-md-6 col-sm-12 col-12 control-margin-top">
                                        <CustomizedTextField
                                            id="place"
                                            label={"Emplacement"}
                                            className="full_size"
                                            multiline
                                            value={this.state.place}
                                            onChange={this.onPlaceChange.bind(this)}
                                        />
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-12 col-12 control-margin-top">
                                        <CustomizedTextField
                                            id="equipment"
                                            label={"Equipement"}
                                            className="full_size"
                                            multiline
                                            value={this.state.equipment}
                                            onChange={this.onEquipmentChange.bind(this)}
                                        />
                                    </div>
                                </div>
                            </CardContent>
                        </Card>
                    </div>
                </div>
                <div className="col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding">
                    <div className="row">
                        <Card className={"card col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding " + (arIsReadonly(this.props.header) ? "disabled" : "")}>
                            <CardHeader style={{ color: 'rgb(117, 117, 117)' }} title="Habilitations/autorisations" className="analyse-risques-card-title"/>
                            <CardContent>
                                <div className="row">
                                    <div className="col-lg-6 col-md-6 col-sm-12 col-12 control-margin-top">
                                        <SelectWithModal
                                            label={"Habilitations"}
                                            onValidate={this.onAccreditationsChange.bind(this)}
                                            id="accreditations"
                                            multiple
                                            menuPlacement="top"
                                            value={selectedAccreditations}
                                            className="full_size"
                                            input={<Input id="accreditations" />}
                                            options={this.props.accreditations.map((ppe) => {
                                                return {
                                                    value: ppe.id,
                                                    label: ppe.name
                                                }
                                            })}
                                        />
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-12 col-12 control-margin-top">
                                        <CustomizedTextField
                                            id="additionnal-information-accreditations"
                                            label={"Informations supplémentaires"}
                                            className="full_size"
                                            multiline
                                            value={this.state.additionnalInformationAccreditations}
                                            onChange={this.onAdditionnalInformationAccreditationsChange.bind(this)}
                                        />
                                    </div>
                                </div>
                            </CardContent>
                        </Card>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        header: state.analyseRisques.header,
        ppeList: state.ppeList.ppeList,
        instructionTypes: state.solutionTypes.types,
        accreditations: state.accreditationTypes.accreditations,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setHeader: (header) => dispatch(setHeader(header)),
    };
};

export default compose(withAuth, connect(mapStateToProps, mapDispatchToProps))(AnalyseRisquesSecurity);
